import { convertToDate } from '../rails_datetime_formatters.js'
import { extractDateFromRailsDateTime  } from '../rails_datetime_formatters.js'

const notBeforeValidator = (date) => (value, _state) => {
  if (value && convertToDate(value) < convertToDate(date)) {
    return `Date can't be before ${extractDateFromRailsDateTime(date)}`
  }

  return null;
};

export default notBeforeValidator;
